<template>
  <div class="main_">
    <top-header :type="11" :placeholder="'请输入项目名称'"  @comfirmText="comfirmText" />
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
      <div class="tab_con m_flex_box flex_ar fixed">
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showArea === true ? 'active' : ''" @click="setTab('showArea', 0)">
            <span class="line_comp1">{{tabText.showArea ? tabText.showArea : '区域'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showArea">
              <p :class="formData.xzqh === item.xzqh_code ? 'active' : ''" @click="setVal('xzqh', item.xzqh_code, item.xzqh_name, 'showArea')"
                v-for="(item, index) in xzqhArray" :key="index">{{item.xzqh_name}}</p>
            </div>
          </transition>
        </div>
        <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showYear === true ? 'active' : ''" @click="setTab('showYear', 1)">
            <span class="line_comp1">{{tabText.showYear ? tabText.showYear : '年份'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showYear">
              <p :class="formData.year === '' ? 'active' : ''" @click="setVal('year', '','年份', 'showYear')">默认</p>
              <p :class="formData.year === item ? 'active' : ''" @click="setVal('year', item, item, 'showYear')" v-for="(item, index) in yearArray" :key="index">{{item}}</p>
            </div>
          </transition>
        </div>
         <div class="inner_con">
          <p class="text m_flex_box flex_vc flex_hc" :class="tab.showCerNo === true ? 'active' : ''" @click="setTab('showCerNo', 2)">
            <span class="line_comp1">{{tabText.showCerNo ? tabText.showCerNo : '预售证号'}}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showCerNo">
              <p :class="formData.cerNo === '' ? 'active' : ''" @click="setVal('cerNo', '','预售证号', 'showCerNo')">默认</p>
              <p :class="formData.cerNo === item ? 'active' : ''" @click="setVal('cerNo', item, item, 'showCerNo')" v-for="(item, index) in cerNoArray" :key="index">{{item}}</p>
            </div>
          </transition>
        </div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="list_con pre_list">
          <div class="inner m_flex_box" v-for="(item, index) in list" :key="index" @click="toDetail(item.SaleItemID)">
            <div class="inner_l">
              <img class="banner" v-lazy="imgPath + 'sImgSale/' + item.SalePermitID+ '.jpg'">
                <i v-show="index<3">最新</i>
            </div>
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{item.tgmc}}</h4>
                <span @click.stop="toPrice(item.id)">一房一价</span>
              </div>
              <div>
                <p class="line_comp1 col_gray m_flex_box flex_vc"><span class="top_text line_comp1">{{item.PlanUse}}</span><i>|</i><span>{{item.CertificateTime}}</span></p>
                <p class="line_comp1 col_gray">{{item.CertificateNO}}</p>
                <p class="line_comp1 col_gray">预售范围：{{item.SaleScope}}</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
export default {
  name: 'AnnouncePre',
  data() {
    return {
      tab: {
        showArea: false,
        showYear: false,
        showCerNo: false,
      },
      tabText: {
        showArea: '',
        showYear: '',
        showCerNo: '',
        showSort: '',
      },
      priceType: 1,
      formData: {
        xzqh: this.main.getHostArea(),
        year: '',
        cerNo:'',
        mc:''
      },
      showPad: false,
      showCover: false,
      loading: false,
      finished: false,
      xzqhArray:[],
      yearArray:[],
      cerNoArray:[],
      xzqhDefault:this.main.getHostArea(),
      items:'',
      listPage:1,
      list:[],
      timer: null,
      isLoading: false,
    };
  },
  components: {
    topHeader,
    slideImg
  },
  mounted() {
    this.getArea();
    this.getYear(this.formData.xzqh);
    this.getCerNo(this.formData.xzqh,this.formData.year);
  },
  methods: {
    toPrice(id) {
      this.$router.push({
        path: '/oneHouseOnePrice',
        query: {
          itemId: id
        }
      })
    },
    comfirmText(data) {
      this.$set(this.formData, 'mc', data);
      this.$set(this, 'listPage', 1);
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad();
    },

    // 获取广告
    onLoad(type) {
      if(!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$new.post('salePermit/getSalePermitListByPage.do', qs.stringify({
          pageSize: 10,
          currPageNo: this.listPage,
          xzqh: this.formData.xzqh,
          cerYear: this.formData.year,
          cerNo: this.formData.cerNo,
          mc: this.formData.mc,
        })).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },
    // 获取默认的行政区划
    getArea() {
      this.$new.post('xzqh/getXzqh.do').then(res => {
        if(res.obj) {
          if(this.xzqhDefault==='320300'){
            this.xzqhArray = res.obj[0].xzqhs;
            this.items = {xzqh_code:'320300',xzqh_name:'不限'};
            this.xzqhArray.splice(0,0, this.items);
          }else{
            res.obj.forEach((item) => {
              if(this.xzqhDefault===item.xzqh_code){
                this.$set(this, 'xzqhArray', [item])
              }
            });
          }
        }
      })
    },
    getYear(area) {
      this.$set(this, 'yearArray', [])
      this.$set(this, 'cerNoArray', [])
      this.$new.post('salePermit/getCerYear.do', qs.stringify({
        xzqh: area
      })).then(res => {
        this.$set(this, 'yearArray', res.obj)
      })
      this.$set(this.tab, 'showCerNo', '');
      this.$set(this.tab, 'showYear', '');
      this.$set(this.formData, 'yesr', '');
      this.$set(this.formData, 'cerNo', '');
      this.$set(this.tabText, 'showYear', '年份');
      this.$set(this.tabText, 'showCerNo', '预售证号');
    },
    getCerNo(area,years) {
      this.$set(this, 'cerNoArray', [])
      this.$new.post('salePermit/getCerNo.do', qs.stringify({
        xzqh: area,
        cerYear:years
      })).then(res => {
        this.$set(this, 'cerNoArray', res.obj)
      })
      this.$set(this.tab, 'showCerNo', '');
      this.$set(this.formData, 'cerNo', '');
      this.$set(this.tabText, 'showCerNo', '预售证号');
    },

    toDetail(saleItemId) {
      this.$router.push({
        path: '/announceDetail',
        query: {saleItemId}
      })
    },
    setTab(type) {
      this.showPad =  true;
      for(let key in this.tab) {
        if(type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false)
        }
        if(this.tab[type]) {
          this.showCover = true
        } else {
          this.showCover = false
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if(tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        this.showCover = false;
      }
      if(type === 'xzqh') {
        this.getYear(this.formData.xzqh)
      }
       if(type === 'year') {
        this.getCerNo(this.formData.xzqh,this.formData.year)
      }
      this.listPage = 1;
      this.loading = true;
      this.finished = false;
      this.$set(this, 'list', []);
      this.onLoad();
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'AnnounceDetail' || to.name === 'OneHouseOnePrice'){
      this.$store.dispatch('saveView', ['AnnouncePre']).then(() => {
        next()
      })
    } else {
      this.$store.dispatch('saveView', []).then(() => {
        next()
      })
    }
  },
};
</script>
<style lang="less" scoped>
.top_text{
  max-width: 50%;
}
.list_main{
  background-color: #fff;
  .tab_con{
    padding: 0 0.16rem;
    font-size: 0.28rem;
    position: relative;
    border-bottom: 1px solid #E9E9E9;
    z-index: 2;
    background-color: #fff;
    &.fixed{
      position: fixed;
      top: 0.9rem;
      left: 0;
      right: 0;
      border-top: 1px solid #E9E9E9;
    }
    .inner_con{
      .text{
        padding: 0.2rem 0rem;
        text-align: center;
        width: 1.2rem;
        .van-icon{
          transition: all 0.3s;
          color: #CECECE;
          transform: rotate(90deg);
          margin-left: 0.06rem;
          font-size: 0.2rem;
        }
        &.active{
          color: #2F72F5;
          .van-icon{
            transform: rotate(-90deg);
            color: #2F72F5;
          }
        }
      }
      .inner_form{
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 0.02rem);
        max-height: 7.12rem;
        overflow: auto;
      }
      .inner_list{
        padding: 0 0.5rem;
        p{
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #F4F4F4;
          text-align: center;
          &:last-child{
            border: none;
          }
          &.active{
            color: #2F72F5;
          }
        }
      }
    }
  }
}
.more_list{
  padding: 0 0.3rem 0;
  .more_con{
    padding-top: 0.46rem;
    height: 5.92rem;
    overflow: auto;
    box-sizing: border-box;
  }
  .btn_con{
    height: 1.2rem;
    box-sizing: border-box;
    border-top: 1px solid #f4f4f4;
    button{
      width: 3.3rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      border-radius: 0.02rem;
      &.reset{
        background-color: #EAF1FF;
        color: #2F72F5;
      }
      &.confirm{
        background-color: #2F72F5;
        color: #fff;
      }
    }
  }
  .row_con{
    margin-bottom: 0.54rem;
  }
  span{
    background-color: #F6F6F6;
    line-height: 0.66rem;
    width: 1.62rem;
    margin-right: 0.12rem;
    border-radius: 0.02rem;
    text-align: center;
    margin-bottom: 0.12rem;
    box-sizing: border-box;
      border: 1px solid #F6F6F6;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &.active{
      color: #2F72F5;
      background-color: #EAF1FF;
      border: 1px solid #2F72F5;
    }
  }
}
.pad_top{
  padding-top: 0.78rem;
}
.list_con{
  margin: 0.05rem auto 0;
  width: 7.04rem;
  .inner{
    padding: 0.35rem 0;
    border-bottom: 1px solid #F4F4F4;
  }
  .banner{
    width: 2.44rem;
    height: 1.84rem;
  }
  .inner_l{
      position: relative;
      i{
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24D064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }
  .new_r{
    .tel{
      width: 0.36rem;
      height: 0.36rem;
      img{
        width: 100%;
      }
    }
    img{
      width: 100%;
    }
    width: 4.25rem;
    margin-left: 0.3rem;
    .col_gray{
      font-size: 0.24rem;
      color: #505050;
      i{
        margin: 0 0.2rem;
      }
    }
    .tit{
      h4{
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }
      i{
        //width: 0.6rem;
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2F72F5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }
      span{
        text-align: center;
        line-height: 0.34rem;
        padding: 0.06rem 0.1rem;
        color: #2F72F5;
        background-color: #E0EAFF;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}
.pre_list{
  .col_gray{
    &:not(:last-child){
      margin: 0.1rem 0;
    }
  }
}
</style>